'use strict';

var Marionette = require('backbone.marionette');

export default Marionette.View.extend({

  className: 'loading',

  render: function () {
    this.$el.html('<i class="fa fa-refresh fa-spin fa-3x"></i>');
    return this;
  },

  show: function () {
    this.$el.show();
  },

  hide: function () {
    this.$el.hide();
  },

});
